export default [
  {
    author: '- Silvija Pećanac Bačić',
    content:
      'Very kind and helpful owners. Mooring gratis. Food is real gourmet experience with homegrown vegetables and fresh seafood.',
    rating: 5
  },
  {
    author: '- Ewan Hemingway',
    content:
      'They serve delicious locally caught seafood, I highly recommend the octopus salad! I think I saw the father of the restaurant owners snorkelling off the moorings to get that nights catch. Lovely atmosphere too!',
    rating: 5
  },
  {
    author: '- Gašper Stružnik',
    content:
      'Nice view on sea, with a very good fish restaurant. They also offer moorings, appartmants with private swimming pool.',
    rating: 5
  }
]



// WEBPACK FOOTER //
// ./src/data/testimonials.js